let lastScrollTop = 0;
let scrollDirection = null;

export function isPageAtTop() {
  let scrollTop = window.scrollY || document.documentElement.scrollTop;
  return scrollTop <= 0;
}

export function isScrollingUp() {
  let scrollTop = window.scrollY || document.documentElement.scrollTop;
  let isScrollingUp = scrollTop < lastScrollTop;
  lastScrollTop = scrollTop;
  scrollDirection = isScrollingUp ? true : false;
  return scrollDirection;
}

export function getScrollDirection() {
  return scrollDirection;
}

export function getScrollTop() {
  return window.scrollY || document.documentElement.scrollTop;
}

export function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}
